import { render, staticRenderFns } from "./PrintAcgih.vue?vue&type=template&id=2bfaf2dc&scoped=true&"
import script from "./PrintAcgih.vue?vue&type=script&lang=js&"
export * from "./PrintAcgih.vue?vue&type=script&lang=js&"
import style0 from "./PrintAcgih.vue?vue&type=style&index=0&id=2bfaf2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfaf2dc",
  null
  
)

export default component.exports